import { render, staticRenderFns } from "./scrolling-contents.vue?vue&type=template&id=4d0db013&"
import script from "./scrolling-contents.vue?vue&type=script&lang=js&"
export * from "./scrolling-contents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports